<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click.stop>
        <div class="bg-white popup">
          <div class="popup-header">
            <h1 class="title">Añadir códigos personalizados</h1>
            <img src="@/assets/images/ic_close.svg" class="close_icon" @click="closePopup(true)" />
          </div>
          <div class="popup-body">
            <div class="fields">
              <label for="name">Añade los nuevos códigos para el plan separados por punto y coma</label>
              <textarea
                id="codes"
                style="width: 100%; resize: none; margin-top: 20px;"
                type="text"
                placeholder="12345678A;12345678B;12345678C"
                v-model="codes"
                rows="8">
              </textarea>
            </div>
          </div>
          <div class="popup-footer">
            <button @click="closePopup(true)" class="secondary_button">Cancelar</button>
            <button @click="saveClicked()" class="main_button">Guardar</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineEmits, defineProps } from 'vue';
  import { useLoadingStore } from "@/stores/loadingStore";
  import { refreshToken } from "@/services/authService";
  import { useRouter } from 'vue-router';

  const props = defineProps({
    planId: Number
  });
  
  const loadingStore = useLoadingStore();
  const router = useRouter();

  const visible = ref(false);
  const planId = ref(0);
  const codes = ref("");

  const emit = defineEmits(['addCinemaCodesSaved', 'addCinemaCodesErrorHappened', 'addCinemaCodesPopupCancelled']);

  watch(() => props.planId, (newVal) => {
    visible.value = newVal > 0;
  });

  const closePopup = (emitEvent) => {
    visible.value = false;
    planId.value = 0;
    codes.value = "";
    if (emitEvent) {
      emit('addCinemaCodesPopupCancelled');
    }
  };

  const saveClicked = async () => {
    loadingStore.setLoading(true);

    try {
      let response = await callAPIToSaveCodes();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await callAPIToSaveCodes();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        loadingStore.setLoading(false);
        emit('addCinemaCodesErrorHappened', 'Se ha producido un error guardando los códigos de cine.');
        return;
      }

      const data = await response.json();

      if (data.errors) {
        loadingStore.setLoading(false);
        emit('addCinemaCodesErrorHappened', data.message);
      } else {
        loadingStore.setLoading(false);
        emit('addCinemaCodesSaved');
        closePopup(false);
      }
    } catch (exception) {
      emit('addCinemaCodesErrorHappened', exception.message);
    }
  }

  async function callAPIToSaveCodes(){
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/add_custom_codes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id'),
        "plan_id": props.planId,
        "codes": codes.value,
      }),
    });
  }

  </script>
  
  <style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .bg-white {
    background-color: white;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .popup-header {
    padding: var(--spacing-md) var(--spacing-lg);
    border-bottom: 1px solid var(--light-gray);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-color-dark);
    margin: 0;
  }

  .close_icon {
    position: absolute;
    right: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity var(--transition-fast);
  }

  .close_icon:hover {
    opacity: 1;
  }

  .popup-body {
    padding: var(--spacing-lg);
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .fields {
    display: flex;
    flex-direction: column;
  }

  .fields label{
    margin-top: 0;
    font-weight: 600;
    font-size: 14px;
    color: var(--text-color-dark);
  }

  .fields input, .fields textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid var(--gray);
    border-radius: var(--radius-md);
    font-family: inherit;
    font-size: 14px;
    transition: border-color var(--transition-fast);
  }

  .fields input:focus, .fields textarea:focus {
    outline: none;
    border-color: var(--primary-color);
  }

  .popup-footer {
    padding: var(--spacing-md) var(--spacing-lg);
    border-top: 1px solid var(--light-gray);
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-md);
    background-color: var(--white);
  }

  .secondary_button, .main_button {
    width: auto;
    min-width: 120px;
  }
  </style>
  